import { Box, Typography } from '@material-ui/core';
import React, { Children, cloneElement, FC, isValidElement, ReactElement } from 'react';
import hoverStyle from 'styles/hover-overlay.module.scss';
import { ObjectPermissionSetData } from 'types/permissions';
import { findPermissionByName } from 'utils/permissions';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import BlockIcon from '@material-ui/icons/Block';

export interface PermissionsControlProps {
 permissions: ObjectPermissionSetData[];
 builderType: string;
 readonlyForChangablePro?: boolean;
 inlineNotChangeableNotice?: boolean;
}

export const PermissionsControl: FC<PermissionsControlProps> = ({
 permissions,
 builderType,
 readonlyForChangablePro,
 inlineNotChangeableNotice = false,
 children,
}) => {

 //grant read only permission for pro type if the changable is false
 const readonlyForPro =
  !findPermissionByName(permissions, 'changeable')?.objectPermissionValue &&
  builderType === 'PRO' &&
  readonlyForChangablePro;

 const changeablePermission = findPermissionByName(permissions, 'changeable');
 const isChangeable =
  changeablePermission?.objectPermissionValue || builderType !== 'PRO' || readonlyForPro;

 // Treat sections as visible by default when no explicit "visible" permission is defined.
 // Only hide (show "Not visible") when there is an explicit visible permission set to false.
 const visiblePermission = findPermissionByName(permissions, 'visible');
 const isVisible = visiblePermission?.objectPermissionValue !== false;

 const enableMouseEvents = isChangeable && isVisible;
 const isNotChangeable =
  !changeablePermission?.objectPermissionValue && builderType === 'PRO';

 return (
  <Box className={hoverStyle.root}>
   {!isVisible && (
    <Box className={hoverStyle.root_content} style={{ visibility: 'visible', opacity: 1 }}>
     <Typography variant='subtitle2' className='d-flex aling-items_center' color='textSecondary'>
      <VisibilityOffIcon fontSize='small' /> <b>Not visible</b>
     </Typography>
    </Box>
   )}
  {/* Show "Not changable" only when the section is visible.
      If it's not visible, prioritise the "Not visible" overlay. */}
  {isVisible && isNotChangeable && (
   inlineNotChangeableNotice ? (
    <Box className={hoverStyle.inline_notice}>
     <Typography variant='subtitle2' className='d-flex aling-items_center' color='textSecondary'>
      <BlockIcon fontSize='small' /> <b>Not changable</b>
     </Typography>
    </Box>
   ) : (
    <Box className={hoverStyle.root_content}>
     <Typography variant='subtitle2' className='d-flex aling-items_center' color='textSecondary'>
      <BlockIcon fontSize='small' /> <b>Not changable</b>
     </Typography>
    </Box>
   )
  )}
   <Box style={{ pointerEvents: enableMouseEvents ? 'unset' : 'none' }}>
    {Children.map(children, child => {
     if(isValidElement(child)) {
         return cloneElement(child as ReactElement<any>, readonlyForPro? { readonly : true}: {})
     }

     return child;
    })}
   </Box>
  </Box>
 );
};
